export const handleEmailRedirect = (email) => {
  if (email) {
    window.location.href = `mailto:${email}?subject=Asunto%20predefinido&body=Mensaje%20predefinido`;
  }
  // if (email) {
  //   const mailtoLink = `mailto:${email}?subject=Asunto%20predefinido&body=Mensaje%20predefinido`;
  //   const a = document.createElement('a');
  //   a.href = mailtoLink;
  //   a.target = '_blank';
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // }
};

export const handleWhatsAppRedirect = (phone, countryCode, message) => {
  if (phone && countryCode) {
    const fullNumber = `${countryCode}${phone}`;
    const messageSend = encodeURIComponent(`¡Hola! Quiero más información sobre ${message}`);
    const whatsappLink = `https://wa.me/${fullNumber}?text=${messageSend}`;
    window.open(whatsappLink, '_blank');
  }
};
